import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Badge,
  FormGroup,
  Alert,
  FormInput,
  FormSelect,
  FormTextarea,
} from "../../components/ui";
import SimpleTable from "../common/SimpleTable";
import dayjs from "dayjs";
import { Modal, ModalHeader, ModalBody } from "../../components/ui";
import NotificationService from "../../components/alerts/index";
import { handleApiError } from "../../utils/apiErrorHandler";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./Invoicestyles.scss";
import {
  getPaymentAllCards,
  getAllEnabledProductsBilling,
  getInvoiceState,
  getSubscriptionStatus,
  getPaymentHistory,
  deletePaymentCard,
  Postcancelplan,
  createPaymentCard,
  renewOrBuySubscription,
  renewSubscription,
  reEnableSubscription,
  changePaymentMode,
  changeWallet,
} from "../../api";
import NFTPage from "../../views/NFTPage";
import withStorage from "../common/WithStorage";
import { withRouter } from "../../hooks/withRouter";
import LoadingOverlay from "../common/LoadingOverlay";
import MaskedInput from "react-text-mask";
import PlansCardsFiterable from "./PlansCardsFilterable";
import logo from "../../images/bitcoin-live/logo.png";
import tickIcon from "../../images/bitcoin-live/tick.svg";

const tableHeadings = ["Product", "Amount Paid", "Payment Method", "Date"];

class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      cardInfo: null,
      isLoading: true,
      history: [],
      modal: false,
      planModal: false,
      cardModal: false,
      showModal: false,
      paymentMethodId: null,
      btcPaymentDialog: false,
      showCancelModal: false,
      showPlans: true,
      disabled: false,
      selectedplanId: "",
      couponId: "",
      openInvoice: false,
      bill: "",
      billaddress: "",
      transactionList: "",
      total: "",
      totalDiscount: "",
      showContent: false,
      refunds: "",
      subTotal: "",
      ownerId: "",
    };
  }

  toggleModal = () => {
    this.setState({
      planChangeOk: !this.state.planChangeOk,
    });
  };

  togglePlanModal = () => {
    this.setState({
      planModal: !this.state.planModal,
    });
  };

  toggleCardModal = () => {
    this.setState({
      cardModal: !this.state.cardModal,
    });
  };

  componentDidMount = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.setState({ user: user });
      const cards = await getPaymentAllCards(user.id);
      const subscription = await getSubscriptionStatus(user.id);
      const paymentHistory = await getPaymentHistory(
        user.id,
        subscription && subscription.data[0].product.id
      );
      const products = await getAllEnabledProductsBilling();
      this.setState(
        {
          cardInfo: cards.data,
          history: paymentHistory.data,
          subscription: subscription.data,
          products: products.data,
          discount:
            subscription.data[0].subscription.nextRenewal.discount !== 0
              ? subscription.data[0].product.cost
              : "",
          paymentMethodId:
            subscription?.data?.[0].subscription?.nextRenewal
              ?.paymentMethodId === 5
              ? 2
              : subscription?.data?.[0].subscription?.nextRenewal
                  ?.paymentMethodId,
          currentProduct: subscription?.data?.[0].product,
          isLoading: false,
        },
        () => {
          if (this.isEnded()) {
            this.setState({ planModal: true });
          }
        }
      );
    }
  };

  refreshData = async () => {
    const { user } = this.state;
    const cards = await getPaymentAllCards(user.id);
    const subscription = await getSubscriptionStatus(user.id);
    const paymentHistory = await getPaymentHistory(
      user.id,
      subscription && subscription.data[0].product.id
    );
    const products = await getAllEnabledProductsBilling();
    this.setState({
      cardInfo: cards.data,
      history: paymentHistory.data,
      subscription: subscription.data,
      products: products.data,
      paymentMethodId:
        subscription.data[0].subscription.nextRenewal.paymentMethodId,
      currentProduct: subscription?.data?.[0].product,
      isLoading: false,
    });
  };

  addCard = async () => {
    let user = this.props.load("user");
    const data = {
      number: this.state.ccNumber.replace(/\s+/g, ""),
      expirationDate: `20${
        this.state.ccExpiration && this.state.ccExpiration.slice(3, 5)
      }-${this.state.ccExpiration && this.state.ccExpiration.slice(0, 2)}`,
      cvc: this.state.ccCVV,
    };
    const createPayment = await createPaymentCard(user.id, data);
    const cards = await getPaymentAllCards(user.id);
    if (createPayment && createPayment.status >= 200 && createPayment.status < 300) {
      this.setState({
        cardInfo: cards.data,
        cardModal: false,
      });
      if (this.state.cardInfo && this.state.cardInfo.cards.length > 1) {
        await deletePaymentCard(user.id, this.state.cardInfo.cards[0].id);
      }
    } else {
      const errorResponse = handleApiError(createPayment, "Failed to add card");
      this.setState({
        cardError: true,
        cardErrorInfo: errorResponse.message,
      });
    }
  };

  payWithBtc = async () => {
    const data = {
      productId: this.state.subscription[0].product.id,
      paymentMethodId: 2, // bitcoin,
      targetUserId: this.state.user.id,
    };
    if (this.state.discount) {
      data["couponName"] = this.state.coupon;
    }
    const sub = await renewOrBuySubscription(this.state.user.id, data);
    if (sub.data && sub.data.url) {
      this.setState({
        btcPaymentDialog: true,
        btcPaymentUrl: sub.data.url,
      });
    }
  };

  renewPlan = async (newPlanId, coupon) => {
    this.setState({
      showModal: false,
      planChangeError: false,
      isLoading: true,
    });
    if (this.state.paymentMethodId === 2) {
      this.setState({
        btcPaymentDialog: true,
        planModal: true,
        isLoading: false,
      });
    }
    const data = {
      productId: newPlanId,
      paymentMethodId: this.state.paymentMethodId
        ? this.state.paymentMethodId
        : this.state.subscription.data[0].subscription.nextRenewal
            .paymentMethodId,
      targetUserId: this.state.user.id,
    };
    if (coupon) {
      data["couponName"] = coupon;
    }
    const sub = await renewSubscription(
      this.state.subscription[0].subscription.id,
      data
    );
    if (sub && sub.status >= 200 && sub.status < 300) {
      const getUrl = await getInvoiceState(sub.data.paymentKey);
      if (getUrl.data && getUrl.data.redirectUrl) {
        this.setState({
          btcPaymentUrl: getUrl.data.redirectUrl,
        });
        const intervalId = setInterval(async () => {
          const invoiceStatus = await getInvoiceState(sub.data.paymentKey);
          if (invoiceStatus.data.paymentStatusId === 5) {
            this.setState({
              planChangeOk: true,
              planModal: false,
              isLoading: false,
              selectedplanId: "",
              couponId: "",
            });
            this.refreshData();
            clearInterval(intervalId);
          }
          if (invoiceStatus.data.paymentStatusId === 4) {
            NotificationService.error(invoiceStatus.data.error);
            this.setState({
              planChangeOk: false,
              planModal: false,
              isLoading: false,
              selectedplanId: "",
              couponId: "",
            });
            this.refreshData();
            clearInterval(intervalId);
          }
        }, 1500);
      }
    } else {
      const errorResponse = handleApiError(sub, "Failed to renew subscription");
      this.setState({
        planChangeError: true,
        planChangeErrorMessage: errorResponse.message,
        isLoading: false,
        selectedplanId: "",
        couponId: "",
      });
    }
  };

  changePlan = async (newPlanId, coupon) => {
    this.setState({
      showModal: false,
      planChangeError: false,
      isLoading: true,
    });
    if (this.state.paymentMethodId === 2) {
      this.setState({
        btcPaymentDialog: true,
        planModal: true,
        isLoading: false,
      });
    }
    const data = {
      productId: newPlanId,
      paymentMethodId: this.state.paymentMethodId
        ? this.state.paymentMethodId
        : this.state.subscription.data[0].subscription.nextRenewal
            .paymentMethodId,
      targetUserId: this.state.user.id,
    };

    if (coupon) {
      data["couponName"] = coupon;
    }
    const sub = await renewOrBuySubscription(this.state.user.id, data);
    if (sub && sub.status >= 200 && sub.status < 300) {
      const getUrl = await getInvoiceState(sub.data.paymentKey);
      if (getUrl.data) {
        this.setState({
          btcPaymentUrl: getUrl.data.redirectUrl
            ? getUrl.data.redirectUrl
            : null,
          btcPaymentDialog: getUrl.data.redirectUrl ? true : false,
          planModal: true,
          isLoading: false,
        });
        const intervalId = setInterval(async () => {
          const invoiceStatus = await getInvoiceState(sub.data.paymentKey);
          if (invoiceStatus.data.paymentStatusId === 5) {
            this.setState({
              btcPaymentDialog: false,
              planChangeOk: true,
              planModal: false,
            });
            this.refreshData();
            clearInterval(intervalId);
          } else if (
            invoiceStatus &&
            invoiceStatus.data.paymentStatusId === 4
          ) {
            clearInterval(intervalId);
            this.setState({
              planChangeError: true,
              planChangeOk: false,
              planChangeErrorMessage: invoiceStatus.data.error,
              isLoading: false,
              btcPaymentDialog: false,
              planModal: true,
              selectedplanId: "",
              couponId: "",
            });
            NotificationService.error(invoiceStatus.data.error);
          }
        }, 1500);
      }
    } else {
      const errorResponse = handleApiError(sub, "Failed to process subscription");
      this.setState({
        planChangeError: true,
        planChangeErrorMessage: errorResponse.message,
        isLoading: false,
        selectedplanId: "",
        couponId: "",
      });
    }
  };

  cancelPlan = async () => {
    this.setState({ showCancelModal: false });
    const cancelPlan = await Postcancelplan(
      this.state.subscription[0].subscription.id
    ).then((resp) => {
      if (resp.status === 200) {
        this.refreshData();
        NotificationService.success("Success");
      }
    });
  };

  selectPlan = (productId) => {
    this.setState({
      newPlanId: productId,
    });
  };

  changeRenewalMethod = async () => {
    const payload = {
      renewalPaymentMethodId: 1,
    };
    const data = await changePaymentMode(
      payload,
      this.state.subscription[0].subscription.id
    );
    if (data.status === 200) {
      this.refreshData();
      NotificationService.success("Payment Method changed");
    }
  };

  changePaymentMethod = (event) => {
    const val = event.target.value;
    this.setState({
      paymentMethodId: val === "bitcoin" ? 2 : 1,
      cardModal: val === "newcard",
    });
  };

  resolveStatus = (statusId) => {
    switch (statusId) {
      case 1:
        return "Active";
      case 2:
        return "Overdue";
      case 3:
        return "Cancelled";
      case 4:
        return "Ended";
      default:
        return "";
    }
  };

  getStatusColor = (statusId) => {
    switch (statusId) {
      case 1:
        return "card-post__category space-left-10 badge-green-type";
      case 2:
        return "card-post__category space-left-10 badge-red-type";
      case 3:
        return "card-post__category space-left-10 badge-orange-type";
      case 4:
        return "card-post__category space-left-10 badge-red-type";
      default:
        return "";
    }
  };

  onPlanClick = (newPlanId, coupon) => {
    this.setState({
      paymentMethodId:
        newPlanId === 5 && this.state.paymentMethodId !== 2
          ? 2
          : this.state.paymentMethodId,
      showModal: true,
      selectedplanId: newPlanId,
      couponId: coupon,
    });
  };

  isEnded = () => {
    return (
      this.state.subscription &&
      this.state.subscription[0].subscription.statusId === 4
    );
  };

  isPendingCancelation = () => {
    return this.state.subscription[0].subscription.statusId === 3;
  };

  reEnableSubscriptionForUser = async () => {
    const resp = await reEnableSubscription(
      this.state.user.id,
      this.state.subscription[0].subscription.id
    );
    if (resp && resp.status >= 200 && resp.status < 300) {
      this.refreshData();
      NotificationService.success("Subscription re-enabled successfully");
    } else {
      const errorResponse = handleApiError(resp, "Failed to re-enable subscription");
      NotificationService.error(errorResponse.message);
    }
  };

  printDocument = () => {
    const name = this.state.user && this.state.user.name;
    const input = document.getElementById("pdfDownload");
    html2canvas(input, { useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      var doc = new jsPDF("p", "mm");
      var imgWidth = 210;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      var position = 0;
      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save(`${name}(Invoice).pdf`);
      this.setState({ openInvoice: false, showContent: false });
    });
  };

  openInvoice = () => {
    const cost = [];
    const discount = [];
    const refund = [];
    const rawTotal = [];
    this.state.history.map((data) => {
      if (data.refundedAmount === undefined) {
        cost.push(data.amount);
        rawTotal.push(data.product.cost);
        discount.push(data.discount);
        refund.push(data.refundedAmount !== undefined && data.refundedAmount);
      }
    });
    this.setState({
      total: cost.reduce((a, b) => a + b),
      totalDiscount: discount.reduce((a, b) => a + b),
      refunds: refund.reduce((a, b) => a + b),
      subTotal: rawTotal.reduce((a, b) => a + b),
      openInvoice: true,
    });
  };

  confirmPrint = () => {
    this.setState({ showContent: true });
    setTimeout(() => {
      this.printDocument();
    }, 1000);
  };

  validateNFTPayment = () => {
    const validateNFT = (this.state.subscription || []).map((data) => {
      if (
        data.subscription.nextRenewal.paymentMethodId === 5 &&
        data.product.id === 5
      ) {
        return true;
      } else {
        return false;
      }
    });
    const filteredData = [...new Set(validateNFT.filter((data) => data))];
    return filteredData[0] || false;
  };

  handleConnectWallet = async (ownerId) => {
    // Prevent repeated API calls for the same address
    if (!ownerId || ownerId === this.state.ownerId) return;
    this.setState({ ownerId });
    const data = {
      walletAddress: ownerId,
    };
    const resp = await changeWallet(data);
    if (resp.status === 422) {
      NotificationService.error(resp.data.error);
    } else if (resp.status === 500) {
      NotificationService.error(resp.data.error || "Something went wrong");
    } else {
      if (resp.status === 200) {
        this.refreshData();
      }
    }
  };

  getQueryParams() {
    const { location } = this.props;
    if (location.pathname.includes("connectWallet")) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.planChangeOk} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            Purchase completed
          </ModalHeader>
          <ModalBody>
            <div className="error__content">
              <img
                src={tickIcon}
                style={{ maxWidth: "70px", margin: "10px" }}
                alt="success"
              ></img>
              <h3>Thank you!</h3>
              <p>Your payment has been succesfully processed.</p>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.cardModal} toggle={this.toggleCardModal}>
          <ModalHeader toggle={this.toggleCardModal}>
            Add New Credit Card
          </ModalHeader>
          <ModalBody>
            <React.Fragment>
              <FormGroup className="form-group">
                <label htmlFor="feCurrPass">Card Holder</label>
                <FormInput
                  id="feNewPass"
                  type="text"
                  className="form-control"
                  placeholder="Your Name"
                  guide={false}
                  onChange={(text) =>
                    this.setState({ ccHolder: text.target.value })
                  }
                />
              </FormGroup>
              <FormGroup className="form-group">
                <label htmlFor="feCurrPass">Card Number</label>
                <MaskedInput
                  id="feNewPass"
                  type="text"
                  className="form-control"
                  mask={[
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                  ]}
                  placeholder="0000 0000 0000 0000"
                  guide={false}
                  onChange={(text) =>
                    this.setState({ ccNumber: text.target.value })
                  }
                />
              </FormGroup>
              <FormGroup className="form-group">
                <label htmlFor="feCurrPass">Expiration Date</label>
                <MaskedInput
                  id="feNewPass"
                  className="form-control"
                  type="text"
                  guide={false}
                  mask={[/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/]}
                  placeholder="MM/YY"
                  onChange={(text) =>
                    this.setState({ ccExpiration: text.target.value })
                  }
                />
              </FormGroup>
              <FormGroup className="form-group">
                <label htmlFor="feCurrPass">CVC</label>
                <MaskedInput
                  className="form-control"
                  id="feNewPass"
                  mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
                  type="text"
                  guide={false}
                  placeholder="000"
                  onChange={(text) =>
                    this.setState({ ccCVV: text.target.value })
                  }
                />
              </FormGroup>
              <Button
                theme="accent"
                className="btn-orange"
                onClick={this.addCard}
              >
                Add
              </Button>
              <br />
              <br />
              {this.state.cardError && (
                <Alert className="mb-0">
                  <i className="fa fa-error mx-2"></i>
                  {this.state.cardErrorInfo}
                </Alert>
              )}
            </React.Fragment>
          </ModalBody>
        </Modal>
        <LoadingOverlay
          active={this.state.isLoading}
          spinner
          text="Loading your content..."
        >
          <Card
            style={{ padding: "30px 0px 0px 12px" }}
            small
            className="mb-4 billing"
          >
            <Row className="line">
              <Col>
                <p className="billing-title">Current Plan</p>
                <p className={`billing-plan`}>
                  {this.state?.currentProduct && (
                    <React.Fragment>
                      {this.state?.currentProduct.name}
                    </React.Fragment>
                  )}
                  <Badge
                    pill
                    className={
                      this.state.subscription &&
                      this.getStatusColor(
                        this.state.subscription[0].subscription.statusId
                      )
                    }
                  >
                    {this.state.subscription &&
                      this.resolveStatus(
                        this.state.subscription[0].subscription.statusId
                      )}
                  </Badge>
                </p>
              </Col>
              <Col
                style={{
                  display:
                    this.state.subscription &&
                    this.state.subscription[0].subscription.statusId === 3
                      ? "none"
                      : "block",
                }}
              >
                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.state.subscription[0].subscription.nextRenewal && (
                    <React.Fragment>
                      <div className="billing-title">
                        {this.state.subscription[0].subscription.statusId ===
                        4 ? (
                          <div>
                            <label
                              style={{
                                color: "#000000",
                                fontSize: 20,
                              }}
                            >
                              Renew Your Plan Today!
                            </label>{" "}
                            <br />
                            <label
                              style={{
                                color: "#000000",
                                fontSize: 20,
                              }}
                            >
                              Select a Plan Below
                            </label>
                          </div>
                        ) : (
                          "Next Payment"
                        )}
                      </div>
                      <p className="billing-data">
                        {this.state.subscription &&
                          this.state.subscription.length > 0 &&
                          (this.state.subscription[0].subscription.statusId ===
                          4 ? (
                            ""
                          ) : (
                            <React.Fragment>
                              {this.state.discount && (
                                <span
                                  className={this.state.discount && "discount"}
                                >
                                  {this.state.subscription[0].subscription
                                    .statusId === 3
                                    ? ""
                                    : `$${this.state.discount}`}
                                </span>
                              )}
                              &nbsp;
                              <span>
                                {this.state.subscription[0].subscription
                                  .statusId === 3
                                  ? ""
                                  : `$${this.state.subscription[0].subscription.nextRenewal.cost}`}
                              </span>
                            </React.Fragment>
                          ))}
                      </p>
                    </React.Fragment>
                  )}

                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.state.subscription[0].subscription.statusId === 4 &&
                  this.state.showCouponError === false && (
                    <React.Fragment>
                      <p className="billing-title">Price</p>
                      <p className="billing-data">
                        {this.state.subscription &&
                          this.state.subscription.length > 0 && (
                            <React.Fragment>
                              <span
                                className={this.state.discount && "discount"}
                              >
                                ${this.state.subscription[0].subscription.cost}
                              </span>
                              {this.state.discount && (
                                <span> ${this.state.discount}</span>
                              )}
                            </React.Fragment>
                          )}
                      </p>
                    </React.Fragment>
                  )}
              </Col>
              <Col>
                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.state.subscription[0].subscription.nextRenewal && (
                    <React.Fragment>
                      <p className="billing-title">
                        {" "}
                        {this.state.subscription[0].subscription.statusId === 4
                          ? ""
                          : this.state.subscription[0].subscription.statusId ===
                            3
                          ? "Access Until"
                          : "Next Renewal Date"}
                      </p>
                      <p className="billing-data">
                        {this.state.subscription &&
                          this.state.subscription.length > 0 && (
                            <React.Fragment>
                              {this.state.subscription[0].subscription
                                .statusId === 4
                                ? ""
                                : this.state.subscription[0].subscription
                                    .nextRenewal.paymentMethodId === 3
                                ? "Complimentary subscription"
                                : this.state.subscription[0].subscription
                                    .nextRenewal.date === null
                                ? "-"
                                : dayjs(
                                    this.state.subscription[0].subscription
                                      .nextRenewal.date
                                  ).format("MMMM Do YYYY")}
                            </React.Fragment>
                          )}
                      </p>
                    </React.Fragment>
                  )}
                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.state.subscription[0].subscription.cancellationDate && (
                    <React.Fragment>
                      <p className="billing-title">Cancellation Date</p>
                      <p className="billing-data">
                        {this.state.subscription && (
                          <React.Fragment>
                            {
                              this.state.subscription[0].subscription
                                .cancellationDate
                            }
                          </React.Fragment>
                        )}
                      </p>
                    </React.Fragment>
                  )}
              </Col>
              <Col className="pt-15">
                {(this.getQueryParams() ||
                  (this.state.subscription &&
                    this.state.subscription.length > 0 &&
                    this.state.subscription[0].subscription.statusId === 4 &&
                    this.validateNFTPayment())) && (
                  <NFTPage
                    setownerId={(value) => {
                      if (value !== "") {
                        this.handleConnectWallet(value);
                      }
                      this.setState({ ownerId: value });
                    }}
                  />
                )}
                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.state.subscription[0].product.id !== 1 &&
                  this.state.subscription[0].product.id !== 5 &&
                  !this.isEnded() &&
                  !this.isPendingCancelation() &&
                  !this.getQueryParams() && (
                    <Button
                      theme="accent"
                      className="btn-blue"
                      onClick={() => {
                        this.setState({ planModal: true });
                      }}
                    >
                      Upgrade Plan
                    </Button>
                  )}
                {this.state.subscription &&
                  this.state.subscription[0].subscription.statusId === 1 &&
                  this.state.subscription[0].subscription.isCancellable &&
                  !this.getQueryParams() && (
                    <Button
                      theme="accent"
                      className="btn-blue"
                      style={{ margin: "0px 10px" }}
                      onClick={() => {
                        this.setState({ showCancelModal: true });
                      }}
                    >
                      Cancel Plan
                    </Button>
                  )}
                {this.state.subscription &&
                  this.state.subscription.length > 0 &&
                  this.isPendingCancelation() &&
                  !this.getQueryParams() && (
                    <Button
                      theme="accent"
                      className="btn-blue"
                      onClick={() => this.reEnableSubscriptionForUser()}
                    >
                      Re-Activate
                    </Button>
                  )}
              </Col>
            </Row>
          </Card>
          <Card small className="mb-4 p-4 billing">
            <Col lg="12">
              <Row>
                <Col lg="2">
                  {this.state.subscription &&
                    this.state.subscription.length > 0 && (
                      <>
                        <p className="billing-title">Payment Method</p>
                        <p
                          style={{ minWidth: "170px" }}
                          className="billing-data"
                        >
                          <FormSelect
                            id="feInputState"
                            onChange={this.changePaymentMethod}
                            value={
                              this.state.paymentMethodId === 1
                                ? "cc"
                                : "bitcoin"
                            }
                          >
                            <option value={""}>Choose ...</option>
                            <option value={"bitcoin"}>
                              Bitcoin{" "}
                              {this.state.subscription &&
                              this.state.subscription[0].subscription
                                .nextRenewal.paymentMethodId === 2
                                ? "✔️"
                                : ""}
                            </option>
                            {this.state.cardInfo &&
                              this.state.cardInfo.cards.length !== 0 && (
                                <option value={"cc"}>
                                  Credit Card{" "}
                                  {`(${this.state.cardInfo.cards[0].last4})`}{" "}
                                  {this.state.subscription &&
                                  this.state.subscription[0].subscription
                                    .nextRenewal.paymentMethodId === 1
                                    ? "✔️"
                                    : ""}
                                </option>
                              )}
                            <option value={"newcard"}>Add New Card</option>
                          </FormSelect>
                        </p>
                      </>
                    )}
                </Col>
                {this.state.paymentMethodId === 2 &&
                  !this.isEnded() &&
                  !this.isPendingCancelation() && (
                    <Col lg="6">
                      <p className="billing-text pt-25">
                        <Button
                          theme="accent"
                          className="btn-blue"
                          onClick={() =>
                            this.renewPlan(this.state.currentProduct.id)
                          }
                        >
                          Renew with Bitcoin
                        </Button>
                      </p>
                    </Col>
                  )}
                <Col lg="6">
                  {this.state.paymentMethodId &&
                    this.state.paymentMethodId === 1 &&
                    this.state.subscription &&
                    this.state.subscription[0].subscription.nextRenewal
                      .paymentMethodId === 2 &&
                    !this.isEnded() &&
                    !this.isPendingCancelation() && (
                      <p className="billing-text pt-25">
                        <Button
                          theme="accent"
                          className="btn-blue"
                          onClick={() => this.changeRenewalMethod()}
                        >
                          Apply Credit Card
                        </Button>
                      </p>
                    )}
                </Col>
              </Row>
            </Col>
          </Card>

          {this.state.planModal && (
            <Card small className="mb-4 p-4 billing">
              <p className="billing-title">Purchase Plan</p>
              <br />
              {this.state.subscription &&
                this.state.subscription.length > 0 &&
                !this.state.btcPaymentDialog &&
                this.state.showPlans && (
                  <PlansCardsFiterable
                    actionText={this.isEnded() ? "PURCHASE" : "UPGRADE"}
                    filterForProduct={
                      this.state.subscription &&
                      this.state.subscription.length > 0 &&
                      this.state.subscription[0].product.id
                    }
                    isEnded={this.isEnded()}
                    bg={"#f1f1f1"}
                    changePlan={this.onPlanClick}
                  />
                )}
              {this.state.btcPaymentDialog && (
                <iframe
                  src={this.state.btcPaymentUrl}
                  style={{ height: 750, width: "100%", border: "none" }}
                  title="btc"
                ></iframe>
              )}
            </Card>
          )}
          <Modal
            centered
            size="md"
            isOpen={this.state.showModal}
            toggle={() => {
              this.setState({ showModal: false });
            }}
          >
            <ModalHeader
              style={{ borderBottom: "none", height: "10px" }}
              toggle={() => {
                this.setState({ showModal: false });
              }}
            ></ModalHeader>
            <ModalBody>
              <div style={{ textAlign: "center" }}>
                <label
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    marginBottom: "25px",
                  }}
                >
                  {" "}
                  {this.isEnded()
                    ? "Are you sure you want to purchase the plan?"
                    : "You will be billed for the upgraded today and you will not loose any unused days - they will be appended to your new subscription."}
                </label>
                <button
                  onClick={() => {
                    this.changePlan(
                      this.state.selectedplanId,
                      this.state.couponId
                    );
                  }}
                  className="alerts-premium-linear"
                >
                  Proceed
                </button>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            size="md"
            isOpen={this.state.showCancelModal}
            toggle={() => {
              this.setState({ showCancelModal: false });
            }}
          >
            <ModalHeader
              style={{ borderBottom: "none", height: "10px" }}
              toggle={() => {
                this.setState({ showCancelModal: false });
              }}
            ></ModalHeader>
            <ModalBody>
              <div style={{ textAlign: "center" }}>
                <label
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to cancel ?
                </label>
                <button
                  onClick={() => {
                    this.cancelPlan();
                  }}
                  className="alerts-premium-linear"
                >
                  Proceed
                </button>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            size="md"
            isOpen={this.state.openInvoice}
            toggle={() => {
              this.setState({ openInvoice: false });
            }}
          >
            <ModalHeader
              style={{ borderBottom: "none", height: "10px" }}
              toggle={() => {
                this.setState({ openInvoice: false });
              }}
            ></ModalHeader>
            <ModalBody>
              <div style={{ textAlign: "center" }}>
                <label
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    marginBottom: "25px",
                  }}
                >
                  Download Transaction Receipt
                </label>
              </div>
              <Form>
                <FormGroup className="form-group">
                  <label htmlFor="feCurrPass">Enter Billing Name</label>
                  <FormInput
                    id="feCurrPass"
                    type="text"
                    placeholder=""
                    value={this.state.bill}
                    onChange={(e) => {
                      this.setState({ bill: e.target.value });
                    }}
                  />
                </FormGroup>
                <FormGroup className="form-group">
                  <label htmlFor="feCurrPass">Address</label>
                  <FormTextarea
                    id="feCurrPass"
                    type="text"
                    placeholder=""
                    value={this.state.billaddress}
                    onChange={(e) => {
                      this.setState({ billaddress: e.target.value });
                    }}
                  />
                </FormGroup>
              </Form>
              <button
                onClick={() => {
                  this.confirmPrint();
                }}
                className="alerts-premium-linear"
              >
                Proceed
              </button>
            </ModalBody>
          </Modal>
          <Card small className="mb-4 p-4 billing">
            <Button
              theme="accent"
              className="btn-blue"
              style={{ margin: "1% 0%", width: "300px" }}
              onClick={() => {
                this.openInvoice();
              }}
            >
              DOWNLOAD TRANSACTION RECEIPT
            </Button>
            <SimpleTable
              tableContent={this.state.history}
              tableHeadings={tableHeadings}
            />
          </Card>
          {this.state.showContent ? (
            <div
              id="pdfDownload"
              style={{ width: "80%", height: "100%", overflow: "auto" }}
            >
              <div className="PdfAddress1">
                <label> Bitcoin Live</label>
                <img className="logo" src={logo} alt="logo" />
              </div>
              <br />
              <label className="PdfAddress2">
                26 Broadway, New York, NY 10004
              </label>
              <br /> <br /> <br />
              <div className="PdfDiv">
                <div className="InvoiceTitle">Invoice</div>
                <div className="InvoiceTitle">
                  <label className="dateHeader">
                    {dayjs().format("MMMM Do , YYYY")}
                  </label>
                </div>
              </div>
              <div className="invoiceDetails">
                <div className="title1">Bill To</div>
                <div className="title2">Ship To</div>
              </div>
              <div
                className="invoiceDetails"
                style={{ marginTop: "10px", borderBottom: "none" }}
              >
                <div className="title1">{this.state.bill}</div>
                <div className="title2">
                  <label>
                    {this.state.billaddress !== ""
                      ? this.state.billaddress
                      : "Digital Product"}
                  </label>
                </div>
              </div>
              <div className="InvoiceData">
                <div className="Row1">Quantity</div>
                <div className="Row2">Description</div>
                <div className="Row3">Date</div>
                <div className="Row4">Discount</div>
                <div className="Row5">
                  <label
                    style={{ float: "right", marginBottom: 0, color: "#fff" }}
                  >
                    {" "}
                    Amount Paid
                  </label>
                </div>
              </div>
              {this.state.history.length > 0
                ? this.state.history.map((data) => (
                    <div className="InvoicecolumnData">
                      <div className="column1">1</div>
                      <div className="column2">
                        {`Bitcoin Live Subscription -${data.product.name}`}
                      </div>
                      <div className="column3">
                        {" "}
                        {dayjs(data.date).format("MMMM Do , YYYY")}
                      </div>
                      <div className="column4">
                        {data.refundedAmount !== undefined
                          ? `${data.refundedAmount}[Refund]`
                          : data.discount + "$USD"}
                      </div>
                      <div className="column5">
                        <label style={{ float: "right" }}>
                          {" "}
                          {data.amount + "$USD"}
                        </label>
                      </div>
                    </div>
                  ))
                : ""}
              <div>
                <div
                  className="InvoicecolumnData"
                  style={{ borderBottom: "none" }}
                >
                  <div className="column1" style={{ marginLeft: "62%" }}>
                    Raw Total [without discount]
                  </div>
                  <div className="column2">
                    <label style={{ float: "right" }}>
                      {" "}
                      {this.state.subTotal + "$USD"}
                    </label>
                  </div>
                </div>
                <div
                  className="InvoicecolumnData"
                  style={{ borderBottom: "none" }}
                >
                  <div className="column1" style={{ marginLeft: "62%" }}>
                    Total Discount
                  </div>
                  <div className="column2">
                    <label style={{ float: "right" }}>
                      {" "}
                      {this.state.totalDiscount + "$USD"}
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="InvoicecolumnData"
                style={{ borderBottom: "1px solid black" }}
              >
                <div className="column1" style={{ marginLeft: "62%" }}>
                  Total
                </div>
                <div className="column2">
                  <label style={{ float: "right", fontWeight: "bold" }}>
                    {this.state.subTotal - this.state.totalDiscount + "$USD"}
                  </label>
                </div>
              </div>
              <div
                className="InvoicecolumnData"
                style={{ borderBottom: "none" }}
              >
                <div
                  className="column1"
                  style={{ marginLeft: "62%", width: "50%" }}
                >
                  Thanks for your business!
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </LoadingOverlay>
      </React.Fragment>
    );
  }
}

Billing.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
};

Billing.defaultProps = {};

export default withStorage(withRouter(Billing));
